<template>
    <div class="over">
        <!-- 能耗 -->
        <EnergyAnalysis />
        <!-- 折标煤 -->
        <FoldingSandard v-if="selectBuildId == ''"/>
        <!-- 发电量统计 -->
        <PowerStatistics v-if="selectBuildId == ''"/>
        <Monitor v-if="selectBuildId == ''"/>
        <!-- <Video v-if="selectBuildId == ''"/> -->
        <Events  v-if="selectBuildId == ''"/>
        <!-- 暖通概况 -->
        <HvacOverview  v-if="selectBuildId != ''" />
        <!-- 照明概况 -->
        <LightingOverview v-if="selectBuildId != ''" />
        <!-- 总功率 -->
        <TotalPower v-if="selectBuildId != ''"/>
        <!-- 尖峰平谷 -->
        <PinnaclesFlat  v-if="selectBuildId != '' && flag"/>
        <!-- 暖通系统设备启停统计 -->
        <DeviceRunStatus />
    </div>
</template>

<script>
    const FoldingSandard = () => import("./components/FoldingSandard")
    const EnergyAnalysis = () => import("./components/EnergyAnalysis")
    const PowerStatistics = () => import("./components/PowerStatistics")
    const Monitor = () => import("../../components/Monitor")
    const Video = () => import("../../components/Video.vue")
    const Events = () => import("../../components/Events")
    const HvacOverview = () => import("./components/HvacOverview")
    const LightingOverview = () => import("./components/LightingOverview")
    const TotalPower = () => import("./components/TotalPower")
    const PinnaclesFlat = () => import("./components/PinnaclesFlat.vue")
    const DeviceRunStatus = () => import("./components/DeviceRunStatus.vue")

    import { getTodayTime } from '../../../utils/common/index'
    export default {
        name: "overview",
        props:{
            selectBuildId:String,
        },
        data() {
            return {
                energyAll:[],
                flag:false,
            };
        },
        components: {
            FoldingSandard,
            Monitor,
            Events,
            PowerStatistics,
            EnergyAnalysis,
            HvacOverview,
            LightingOverview,
            TotalPower,
            PinnaclesFlat,
            DeviceRunStatus
        },
        mounted() {
            this.getDateEnergyProject()
        },
        methods: {
            async getDateEnergyProject(){
                let time = getTodayTime()
                let data = {
                    date:`${time}T00:00:00Z`,
                    projectId:this.$store.state.projectId,
                    range:'MONTH'
                }
                let res = await this.$http.getDateEnergyProject(data)
                console.log(res);
                this.energyAll = res.data.data.result
            },
            async getBuildTreeEnergy(){

            }
        },
        activated(){
            this.flag = true
        },
        deactivated(){
            this.flag = false
        }
    };
</script>

<style lang="less" scoped>
  .over{
      z-index: 1;
  }

    
</style>